import { CASHIER_ITEM_MENU } from "../../constants/kasir/constant";

const initialState = {
  loadingGetItemMenuCashier: true,
  loadingStoreItemMenuCashier: false,
  dataGetItemMenuCashier: [],
};

export const itemMenuCashierReducer = (state = initialState, action) => {
  switch (action.type) {
    case CASHIER_ITEM_MENU.GET_ITEM_MENU_CASHIER:
      return {
        ...state,
        dataGetItemMenuCashier: action.data,
      };
    case CASHIER_ITEM_MENU.LOADING_GET_ITEM_MENU_CASHIER:
      return {
        ...state,
        loadingGetItemMenuCashier: action.load,
      };
    case CASHIER_ITEM_MENU.LOADING_STORE_ITEM_MENU_CASHIER:
      return {
        ...state,
        loadingStoreItemMenuCashier: action.load,
      };
    default:
      return state;
  }
};
